import { useSelector } from 'react-redux';
import { deliverableManagementApi, useFetchDeliverableIdsQuery } from '~/api/deliverables/DeliverablesManagement.api';
import { DeliverableSearchCriteriaDeliverableTypeEnum } from '~/api/models/deliverable-search-criteria';

export const useGetAllDeliverablesIds = (deliverablesTypes : DeliverableSearchCriteriaDeliverableTypeEnum[]) => {
    deliverablesTypes.forEach(type => {
        useFetchDeliverableIdsQuery({ deliverableType: type });
    });

    return useSelector(state => {
        return deliverablesTypes.flatMap(type => {
            const result = deliverableManagementApi.endpoints.fetchDeliverableIds.select({ deliverableType: type })(state);
            const ids = result?.data?.content || [];
            return ids.map(id => ({ id, type }));
        });
    });
};
